<script>
  export let pct;
  export let handleBack;
  let email = '';
  let emailConfirm = '';
  let showApplicant;
  let showAgent;
  let showPayment;
  let invalid, invalid1, invalid2, invalid3, invalid4, invalid5;
  let error = '';
  let first, last, address, city, state, zip, country;
  let regex;
  let agentName, agentCompany, agentEmailOther, agentEmailBilling, passcode, instructions;
  function checkForm() {
    if (email != emailConfirm) {
      invalidateEmail();
      error = 'Email does not match!';
    } else {
      invalid = false;
      error = '';
    }
  }
  function invalidateEmail() {
    invalid = true;
  }
  function handleApplicant() {
    showApplicant = true;
    showAgent = false;
  }
  function handleAgent() {
    showAgent = true;
    showApplicant = false;
  }
  function handleSubmit() {
    if(!agentName) {
      invalid1 = true;
    } else {
      invalid1 = false;
    }
    if(!agentEmailOther) {
      invalid2 = true;
    } else {
      invalid2 = false;
    }
    if(!agentEmailBilling) {
      invalid3 = true;
    } else {
      invalid3 = false;
    }
    if(!passcode) {
      invalid4 = true;
    } else {
      invalid4 = false;
    }
    if(!agentCompany) {
      invalid5 = true;
    } else {
      invalid5 = false;
    }
    if(agentName && agentEmailOther && agentEmailBilling && passcode && agentCompany) {
      invalid1 = false;
      invalid2 = false;
      invalid3 = false;
      invalid4 = false;
      invalid5 = false;

      let password_check_url = 'https://bce70q6zdh.execute-api.us-west-2.amazonaws.com/default';
      let step_function_url = 'https://k2y2eh9x62.execute-api.us-west-2.amazonaws.com/pctsf';

      let data = {
        pct,
        address: 'sample address',
        city: 'sample city',
        state: 'sample state',
        "zip code": 'zip code',
        country: 'country',
        company: agentCompany,
        name:agentName,
        email: agentEmailOther,
        billingEmail: agentEmailBilling,
        to: agentEmailOther,
				website: 'http://patenttrademarkblog.com/pct/declaration.html',
				generate: '1',
        stateMachine: '1',
        passcode,
        instructions
      };

      if(pct) {
        fetch(password_check_url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "text/plain"
          }
        }).then(res => res.json())
          .then(response => {
            console.log("response",response);
            if (response.hasOwnProperty("errorType")) {
    					alert(response["errorMessage"]);
    				} else {

              fetch(step_function_url, {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                  "Content-Type": "text/plain"
                }
              }).then(res => res.json())
                .then(response => {
                  handleBack();
                  alert("Your application was submited, please check your email.")
                });
            }
          });
      }
    }
  }
  function handlePayment() {
    let url = 'https://x2ttjt40ml.execute-api.us-west-2.amazonaws.com/default';
    let step_function_url = 'https://k2y2eh9x62.execute-api.us-west-2.amazonaws.com/pctsf';
    let data = {
      "to": "dtle82@gmail.com,vlin@icaplaw.com",
      "attachment": 1,
      "generate":1,
      "stateMachine": 1,
      "website": "http://patenttrademarkblog.com/pct/declaration.html",
      first,last,address,city,state,zip,email,pct,country
    };
    if(first && last && address && city && state && zip && email && country) {
      fetch(step_function_url, {
  			method: "POST",
  			body: JSON.stringify(data),
  			headers: {
  				"Content-Type": "text/plain"
  			}
  		}).then(res => res.json())
        .then(response => {
        console.log("response", response);

        if(response.status == "processing"){
          window.open(`https://secure.lawpay.com/pages/icaplaw/usnationalstage?name=${first}%20${last}&address1=${address}&city=${city}&state=${state}&postal_code=${zip}&email=${email}`);
          showApplicant = false;
        }

      });

    } else {
      alert('Please fill out required information');
    }

  }
</script>
<div>
  <h1>Order Details</h1>
  <p>PCT: {pct}</p>

  <p>Please let us know if you are the applicant or an agent? (only 2 options)<p>

  <div class="buttonDiv">
    <div>
      <button on:click={handleBack}>Back</button>
    </div>
    <div>
      <button on:click={handleApplicant}>Applicant</button>
      <button on:click={handleAgent}>Agent</button>
    </div>
  </div>

    {#if showApplicant}
      <h4 class="due">TOTAL DUE NOW: $790</h4>
      <h4>Engagement Agreement</h4>
    <div class="disclaimer">
    <p>This letter sets forth the terms that apply to the representation of the Client by Innovation Capital Law
Group, LLP (“our,” “us,” “we,” or the “Firm) in connection with legal services, i.e., intellectual property, corporate,
securities, or other legal matters, some of which may not be pertinent to you.</p>
    <h3>1. Conflicts of Interest</h3>
    <p>Initially, our Firm&#39;s intake procedures require receiving and approving an executed copy of your
agreement to this engagement, checking for any conflicts of interest based upon the information that you have
provided us about you and your matter(s), taking certain other routine clerical steps, and receiving your retainer.
Subject to satisfying these procedures, we will open a matter and commence work for you. Should it later develop
that a conflict of interest exists or has developed, we will immediately contact you to determine what options we
have within the canons of ethics to resolve the matter or to help you obtain other counsel.</p>
    <h3>2. Scope of Agreement.</h3>
    <p>To confirm our understanding, you have agreed to engage our services in connection with general
intellectual property and corporate legal services. <u>This engagement does <b>not</b> include representing you in any
particular litigation in federal or state court, for which a separate litigation engagement agreement will be
required.</u></p>
  <p>Flat rates for patent and trademark prosecution matters are published on our website at
<a href="http://www.icaplaw.com/flat-fees">http://icaplaw.com/flat-fees.</a> If we provide you with an estimate of the fees necessary to complete a specific
project within that matter, we may require receipt of those funds prior to beginning that project. This estimate
practice is often the case with respect to patent, trademark and copyright prosecution matters. If a particular
matter is billed on an hourly basis, the hourly rates in our firm presently range from $90 for certain paralegals or
law clerks to $550 and up for the most experienced attorneys working on the most complicated and difficult
matters. Our rates will be adjusted from time to time. We reserve the right to change the staffing of any matter
as we deem fit.</p>
  <h3>3. Costs and Expense</h3> <p>To save the burdensome cost of accounting, our Firm does not separately itemize minor expenses such as
postage, photocopies, local and long-distance telephone charges and other miscellaneous items. During our
representation of you, we may also incur various expenses particular to your matters. We may require upfront
payment to cover these expenses. You agree to reimburse us for all of these expenses (&quot;costs&quot;) paid by us, or if
you are billed directly for these expenses, to make prompt, direct payments to the originators of the bills. You
authorize us to incur these reasonable costs on your behalf, and for us to pay the same out of any funds in our
trust account as they become due.</p>
  <p>These costs and expenses may include, but are not limited to, the following: filing fees, messenger and
other delivery fees, research expenses, consultants and expert witness fees, express mail or other overnight
courier charges, outside photocopying and other reproduction, and other similar expenses that we may reasonably
incur. It may be necessary to hire vendors to aid in the preparation or presentation of a case. You or we may also
deem it prudent to utilize the expertise of an attorney outside of this office for certain phases of your
representation. You authorize us to incur all reasonable costs and to hire any associate attorney, independent
contractor, illustrator, researcher, consultant or expert witness reasonably necessary or appropriate in our
judgment unless you specifically instruct us, in writing, not to do so and accept the responsibility of that decision.
You will be responsible for such person’s fees and charges, and you agree, at our option, to make separate
financial arrangements with that person and agree that the money supplied by you to us pursuant to this letter
agreement is not intended to be applied toward any amounts due to any such person. If we advance fees and
costs to such persons on your behalf, these costs will be itemized on our invoices, and you are required to pay such
costs.</p>
  <h3>4. Statements, Manner of Billing and Payment.</h3>
  <p>Each client is assigned a separate client code, and each matter for that client is assigned a separate matter
code. In addition, disbursements may also be recorded based upon client and matter reference.</p>
<p>We will tender our invoices for fees and expenses at such intervals as we deem appropriate, usually
monthly. All invoiced amounts are immediately due and payable. If payment is not received within thirty (30) days
following the date of any invoice in question, a late payment charge of one percent (1%) of the outstanding
balance owed may be added to your statement for the month following the date of such unpaid invoice and for
each month thereafter until payment is received. The undersigned, as individuals, and the Client will be jointly and
severally responsible for all obligations owed to us.</p>
<p>In fairness to the majority of the firm&#39;s clients who pay their bills promptly each month, late payment
charges have been established so that the minority of clients whose accounts become delinquent will bear the
firm&#39;s cost of late payment. This enables us to render top quality legal services at the lowest possible expense to
our clients. Additionally, any clients who are consistently late in their payments will be considered for higher
billing rates to account for the increased burden.</p>
  <h3>5. Retainer and Deposit</h3>
  <p><u>A retainer will be required for new clients. You acknowledge that you have not engaged our firm unless
and until you provide the required retainer.</u> In each case, we will inform you of any required initial retainer, and
will not start working until it is received.</p>
  <h3>6.Replacement, Discharge, Withdrawal, Termination or Conclusion.</h3>
  <p>We will endeavor to represent you promptly and efficiently according to the highest legal and ethical
standards. However, you have the right to terminate our services at any time upon written notice to us. We also
have the right to terminate our services to you, at any time upon written notice. Some of the reasons we might
choose to withdraw would be: (1) your breach of this agreement, (2) your refusal to cooperate with us or to follow
our advice on a material matter, including your refusal to accept a settlement offer we recommend to a
controversy, or (3) any fact or circumstance that would render our continuing representation of you unlawful or
unethical. We each agree to sign any documents reasonably necessary to complete any such termination. Upon
the termination of our representation of you, all unpaid charges for services rendered and costs incurred or
advanced through the termination date shall become immediately due and payable.</p>
  <p>Our office does not keep physical files, but rather electronic copies of all new matters. We acknowledge
our obligation, upon your demand, to send you an electronic copy of your matter at or after the termination or
conclusion of our services. Upon the completion of the performance of work on the retained matter, you must
notify us, in writing, of your request to retain an electronic copy of the file. If you do not wish to retain the file or
should you not notify us in writing within thirty (30) days of the completion of your matter, then you authorize us
to discard all electronic copies of your matter.</p>
  <p>In the filing and prosecution of any patent, trademark or copyright applications, our engagement
automatically terminates upon that application either issuing or going abandoned. While we often endeavor to
calendar and remind you of the filing and payment of maintenance fees, renewals, taxes or annuities (if
applicable), we accept no responsibility for doing so. It is incumbent upon you to schedule these dates for
yourself.</p>
  <h3>7.Disputes and Arbitration.</h3>
  <p>We are proud to say that our firm has seldom had disagreements with its clients. However, some
disputes occasionally occur, and we generally resolve those through amicable discussion. If a dispute arises
between us over fees charged for services, the controversy will be submitted to Arbitration in accordance with the
rules of the California State Bar Fee Arbitration Program, as set forth in California Business and Professions Code
sections 6200 through 6206.  The prevailing party in any litigation regarding a fee dispute will be awarded
reasonable attorney’s fees and costs incurred in that litigation.</p>
  <h3>8.Client’s Duty to Maintain Updated Contact Information with Firm.</h3>
  <p>Since we correspond with you primarily via email, it is important for us to have your updated contact
information so that we can promptly notify you of any significant matters and deadlines. <b>You hereby agree to
notify the firm of any changes in email addresses, mailing addresses and telephone numbers.</b></p>
  <h3>9.Disclaimer of Guarantee.</h3>
  <p>We cannot, will not and have not made any representations, promises or guarantees to you about the
outcome or success of any matter. Nothing in this agreement shall be construed as such a promise or guarantee,
and your obligation to pay the fees and costs incurred in connection with any matter is not dependent in any way
on our success in any of your matters.</p>
  <h3>10.Attorneys’ Lien on Recovery.</h3>
  <p>As security for payment of our professional fees and outofpocket costs, you hereby grant us a lien on your
intellectual property which is the subject of our representation, on any recoveries from litigation involving such
intellectual property and on any other proceeds of such intellectual property. Our lien is for the outstanding sums
owed to us during and at the conclusion of the performance of our services. In connection with this lien, you
hereby appoint us as your attorneysinfact with full authority to execute any documents necessary to perfect our
lien. Because a lien may affect your property rights, you may seek the advice of an independent lawyer of your
choice before agreeing to such a lien.</p>
  <h3>11.Going Paperless.</h3>
  <p>In an effort to help the environment and reduce your clutter, we will send you copies of documents and
correspondences in electronic format instead of hard copies except for original certificates.</p>
  <h3>12.Consent to Firm’s Disclosure of Representation.</h3>
  <p>You acknowledge that the fact of Client’s representation by the firm is not confidential. You hereby
consent to our disclosure of the firm’s representation of Client. You also consent to our use of Client’s logos and
trademarks for marketing purposes and acknowledge that such usage by the firm constitutes fair use under U.S.
trademark and copyright laws.</p>
  <h3>13.Additional Matters.</h3>
  <p>If you request us to represent you in additional matters, a new engagement letter will not be prepared,
unless we both agree otherwise in writing. Absent a new engagement letter, the terms of this letter shall control
any additional matters.</p></div>
  <h4>CONTACT INFORMATION</h4>
  <div class="names">
      <label for="input_4_22_3">First*</label><input bind:value={first} name="input_22.3" type="text" />
      <label for="input_4_22_6">Last*</label> <input bind:value={last} name="input_22.6" type="text" />
  </div>
  <div class="address">
    <label for="i-address">Street Address*</label><input bind:value={address} name="i-address" type="text" />
    <label for="i-city">City or Town*</label><input bind:value={city} name="i-city" type="text" />
    <label for="i-state">State*</label>
    <select name="i-state" bind:value={state}><option value="">Select State*</option><option value="Other">Other (non-US Country)</option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AS">American Samoa</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="AA">Armed Forces Americas</option><option value="AE">Armed Forces Europe</option><option value="AP">Armed Forces Pacific</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District of Columbia</option><option value="FM">Federated States of Micronesia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="GU">Guam</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MH">Marshall Islands</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="MP">Northern Mariana Islands</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PW">Palau</option><option value="PA">Pennsylvania</option><option value="PR">Puerto Rico</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VI">Virgin Islands</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option></select>
    <label for="i-zip">Zip or Postal Code*</label><input bind:value={zip} name="i-zip" type="text" />
    <label for="i-country">Country*</label><input bind:value={country} name="i-country" type="text" />
  </div>
  <div class="email">
    <label class:invalid = {invalid} for="i-email">Email*</label>
    <input class:invalid = {invalid} bind:value={email} name="i-email" type="text" />
    <div class="error">{error}</div>
    <label class:invalid = {invalid} for="i-emailConfirm">Confirm Email*</label>
    <input on:change={checkForm} class:invalid = {invalid} bind:value={emailConfirm} name="i-emailConfirm" type="text" />
    <div class="error">{error}</div>
  </div>
  <b>Agreed to and Accepted By:</b>
  <div class="signature">
    <label for="i-signature">Signature*</label>
    <input name="i-signature" type="text" value="" />
  </div>

    <img on:click={handlePayment} src="https://info.affinipay.com/rs/433-TWV-220/images/LP_MakePayment_ALL.png"/>
    {/if}

    {#if showAgent}
      <div class="form-group" id="name_field">
        <label class:invalid = {invalid1} for="name">Name of Main Contact*</label>
        <input class:invalid = {invalid1} type="text" class="form-control" name="name" id="name" placeholder="" bind:value={agentName} />
      </div>
      <div class="form-group" id="company_field">
        <label class:invalid = {invalid5} for="company">Company*</label>
        <input class:invalid = {invalid5} type="text" class="form-control" name="company" id="company" placeholder="" bind:value={agentCompany} />
      </div>
      <div class="form-group" id="emailBilling_field">
        <label class:invalid = {invalid2} for="emailBilling">Email for billing*</label>
        <input class:invalid = {invalid2} type="text" class="form-control" name="emailBilling" id="emailBilling" placeholder="" bind:value={agentEmailBilling} />
      </div>
      <div class="form-group" id="emailOther_field">
        <label class:invalid = {invalid3} for="emailOther">Email for other communications*</label>
        <input class:invalid = {invalid3} type="text" class="form-control" name="emailOther" id="emailOther" placeholder="" bind:value={agentEmailOther} />
      </div>
      <div class="form-group" id="passcode_field">
        <label class:invalid = {invalid4} for="passcode">Passcode*<br>(please email <a href="mailto:processing@icaplaw.com">processing@icaplaw.com</a> to request passcode)</label>
        <input class:invalid = {invalid4} type="text" class="form-control" name="passcode" id="passcode" placeholder="" bind:value={passcode} />
      </div>
      <div class="form-group" id="instructions_field">
        <label class:invalid = {invalid4} for="instructions">Special Instructions</label>
        <textarea class:invalid = {invalid4} type="text" class="form-control" name="instructions" id="instructions" placeholder="" bind:value={instructions} rows="3" cols="40"></textarea>
      </div>
      <button on:click={handleSubmit}>Submit</button>
    {/if}
</div>

<style>
.buttonDiv {
  display: grid;
  grid-template-areas: "a b c";
}
.disclaimer {
  font-size: 11px;
  height: 260px;
  overflow: auto;
  border: 1px solid #ccc;
  text-align: left;
}
strong {
  padding-left: 20px;
}
h4.due {
  color: #800000;
}
h3 {
  text-decoration: underline;
}
a {
  color: blue;
  text-decoration: underline;
}
.names, .address, .email, .signature {
  display: grid;
  grid-template-areas: "a b"
                        "c d";
  text-align: left;
  grid-template-columns: .5fr 2fr;
}
.invalid {
  border: 1px solid red;
  color: red;
}
label.invalid {
  border:0px;
}
.error {
  grid-column: 2;
  color: red;
}
</style>
